export default __webpack_public_path__ + "static/media/etheruem-logo.df75c98c.svg";